"use client";

import { BillingPlanBenefit } from "@jurni/schemas";
import { CheckedLabel } from "./checked-label";

interface PlanBenefitsProps {
  benefits: BillingPlanBenefit[];
  isSuggested?: boolean;
}

export const PlanBenefits = ({ benefits, isSuggested }: PlanBenefitsProps) => {
  return (
    <div className="min-h-0 flex-1 space-y-3 overflow-y-auto pr-1">
      {benefits.map((benefit, idx) => (
        <div key={idx} className="space-y-1.5">
          <div className="text-[13px] font-semibold leading-5 text-foreground">
            {benefit.title}
          </div>
          {benefit.items.map((item, itemIdx) => (
            <CheckedLabel
              key={itemIdx}
              label={item}
              checkClassName={isSuggested ? "text-primary" : ""}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
